module.exports = __webpack_public_path__ + "static/media/ch.252c409b.svg";